export default __webpack_public_path__ + "static/media/dc-logo2.2b9fde32.webp";